/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosTokenActionInfo = {
    ACTTP: AptosTokenActionInfo.ACTTP;
};

export namespace AptosTokenActionInfo {

    export enum ACTTP {
        MINT = 'MINT',
        BURN = 'BURN',
        TRANSFER = 'TRANSFER',
        MUTATE = 'MUTATE',
        BIDDING = 'BIDDING',
        CANCEL_BIDDING = 'CANCEL_BIDDING',
        COLLECTION_BIDDING = 'COLLECTION_BIDDING',
        COLLECTION_CANCEL_BIDDING = 'COLLECTION_CANCEL_BIDDING',
        LISTING = 'LISTING',
        DELIST = 'DELIST',
        SOLD = 'SOLD',
        UPDATE_PRICE = 'UPDATE_PRICE',
    }


}

